import React, { FunctionComponent } from "react";

import { BackToStore } from "../blocks/BackToStore/BackToStore";
import { Meta } from "../blocks/Meta/Meta";
import { AccessoryDetails } from "../blocks/ProductDetails/Accessory/AccessoryDetails";
import { PackageDetails } from "../blocks/ProductDetails/Package/PackageDetails";
import { TireDetails } from "../blocks/ProductDetails/Tire/TireDetails";
import { WheelDetails } from "../blocks/ProductDetails/Wheel/WheelDetails";
import {
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../constants/productTypes";
import { DealerProductDetailsRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { useGetAccessoryByPartId } from "../queries/useGetAccessoryByPartId";
import { useGetPartPackageByPartId } from "../queries/useGetPartPackageByPartId";
import { useGetTireByPartId } from "../queries/useGetTireByPartId";
import { useGetWheelByPartId } from "../queries/useGetWheelByPartId";

export const DealerProductDetailsPage: FunctionComponent = () => {
  const params = useRouteParams(DealerProductDetailsRoute);
  return (
    <>
      <Meta cmsTitle={null} title="dealerProductDetailsPage" />
      <BackToStore className="mt-8 lg:mt-12 mb-2" />
      {params?.productType === productTypeAccessory && (
        <AccessoryDetails part={useGetAccessoryByPartId().data ?? null} />
      )}
      {params?.productType === productTypePackage && (
        <PackageDetails part={useGetPartPackageByPartId().data ?? null} />
      )}
      {params?.productType === productTypeTire && (
        <TireDetails part={useGetTireByPartId().data ?? null} />
      )}
      {params?.productType === productTypeWheel && (
        <WheelDetails part={useGetWheelByPartId().data ?? null} />
      )}
    </>
  );
};
